import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { BackofficeUserListRouter } from '@flows/private/backofficeUser/pages/BackofficeUserList/router';

import { SidebarRouteButton } from '../SidebarRouteButton';

export function BackofficeManagement() {
  return (
    <SidebarRouteButton
      route={BackofficeUserListRouter}
      stackProps={{ border: `1px solid ${NEW_COLORS.GRAYSCALE[700]}` }}
    />
  );
}
